import { Box, Button, Grid, makeStyles } from "@material-ui/core";
import * as React from "react";
import { Cropper, CropperRef, RectangleStencil } from "react-advanced-cropper";
import { SvgIcon } from "../../../../components";
import { base64toFile, tl } from "../../../../utils";
import { MUIDialog } from "../Dialog";

interface CropperDialogProps {
  /**
   * @image base64 image data
   */
  image: string | null | undefined,
  file?: File
  onCancel: () => void;
  onConfirm: (imageFile: File) => void;
  aspect?: number;
  minWidth?: number;
  minHeight?: number;
}

export const CropperDialog: React.FC<CropperDialogProps> = ({
  aspect,
  minHeight,
  minWidth,
  image,
  file,
  onCancel,
  onConfirm
}) => {
  const classes = useStyles()
  const imgRef = React.useRef<CropperRef>(null);
  const handleRotate = (value: number) => {
    if (imgRef.current) {
      imgRef.current.rotateImage(value);
    }
  };

  const generateFile = (e: React.MouseEvent) => {
    e.preventDefault();
    const cropper = imgRef?.current;
    if (cropper && file) {
      const data = cropper.getCanvas().toDataURL(file.type);
      const imageFile = base64toFile(data, file.name, file.type);
      onConfirm(imageFile)
    }
  }
  return (
        
    <MUIDialog
      maxWidth={"md"}
      mobileFullWidth
      actionsInline
      open={!!image}
      // dialogContentClassName={classes.dialogContent}
      style={{overflow: "hidden"}}
      // PaperProps={{
      //   style: {minHeight: 220}
      // }}
      pInner={0}
      title={file ? file.name : "Выберите область"}
      actions={[
        [],
        [
          {
            label: tl("Отмена"),
            btnProps: {
              onClick: () => {
                onCancel()
            
              },
            },
          },
          {
            label: tl("Подтвердить"),
            btnProps: {
              color: "primary",
              onClick: generateFile
            },
          },
        ],
      ]}
    >
      {image && (
        <div className={classes.crop}>
          <Cropper
            ref={imgRef}
            src={image}
            style={{maxHeight: "calc(100vh - 200px)"}}
            stencilComponent={RectangleStencil}
            stencilProps={{
              aspectRatio: aspect || 0,
              resizeable: true,
              moveable: true,
              handlerClassNames: {
                default: classes.stencilHandler
              }
            }}
            minWidth={minWidth}
            minHeight={minHeight}
            imageRestriction="fitArea"
            backgroundClassName={classes.cropArea}
          />
          {/* опасно для жизни, нужно при перевороте менять скейл изображения */}

          <Box pt={1} pr={1} className={classes.cropRotate}>
            <Grid container spacing={1}>
              <Grid item>
                <Button
                  variant="contained"
                  className="MuiButton-iconAction"
                  onClick={() => {
                    handleRotate(-90);
                  }}
                >
                  <SvgIcon type="rotate-rcw" />
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  className="MuiButton-iconAction"
                  onClick={() => {
                    handleRotate(90);
                  }}
                >
                  <SvgIcon type="rotate-cw" />
                </Button>
              </Grid>
            </Grid>
          </Box>
        </div>
      )}
    </MUIDialog>
  )
}


const useStyles = makeStyles((theme) => ({
  crop: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    minHeight: 120,
    maxHeight: "calc(100vh - 150px)",
    "& .cropper-line": {
      backgroundColor: theme.palette.primary.light,
    },
    "& .cropper-point": {
      backgroundColor: theme.palette.primary.light,
    },
  },
  cropArea: {
    background: "transparent",
  },
  cropRotate: {
    position: "absolute",
    top: 0,
    right: 0,
  },
  stencilHandler: {
    background: theme.palette.grey.A700,
  },
}))